import React, { useContext } from "react";
import "./AccessCodeRegister.scss";
import { Button } from "@activehub/common-components-spa-resource";
import { AppContext } from '../../App';
import { AbilityContext } from '@activehub/common-components-spa-resource';

const ActivationSuccessTemplate = (props) => {
    const {
        availableSPAs,
        redeemedResponse
    } = useContext(AppContext);
    const ability = useContext(AbilityContext);
    const userRole = ability.can("VIEW", "LESSON_PLAN") ? "Instructor": ability.can("VIEW", "STUDENT_HOME") ? "Learner": "Admin";
    const redirectionText = (userRole === "Learner") ? "My library" : "Resources";
    const handleGoToResources = () => {
        const activeHubUrl = window.location.origin;    
        if(userRole === "Instructor" || userRole === "Admin"){
        const filteredLessonPlan = availableSPAs && availableSPAs.filter(i => { return i?.styleSheetElementBaseName === "lessonPlan" })
         window.location.href = `${activeHubUrl}/#/application/${encodeURIComponent(filteredLessonPlan?.[0]?.spaId)}/courseInstance`;
        }else if(userRole === "Learner"){
        const filteredStudentHome = availableSPAs && availableSPAs.filter(i => { return i?.styleSheetElementBaseName === "studentHome" })
         window.location.href = `${activeHubUrl}/#/application/${encodeURIComponent(filteredStudentHome?.[0]?.spaId)}/studentebook`;
        }
        setTimeout(() => {
            if(userRole === "Learner"){
                const filteredStudentHome = availableSPAs && availableSPAs.filter(i => { return i?.styleSheetElementBaseName === "studentHome" })
                 window.location.href = `${window.location.origin}/#/application/${encodeURIComponent(filteredStudentHome?.[0]?.spaId)}/studentebook`;
            }
            window.location.reload();   
        }, 10);
        
    }

    return (<div className="access-code">
        <h4>Access code activated successfully</h4>
        <div className="activation-details">
             <div><span className="title-bold">{redeemedResponse?.ebookTitle}</span> has now been added to {redirectionText}.</div>
            <div>Activation date: {redeemedResponse?.startDate}</div>
            <div>Expiry date: {redeemedResponse?.expireDate}</div>
        </div>

        <Button className="next-step" tabIndex={true ? 0 : -1} onClick={handleGoToResources}>
           {userRole === "Learner" ? "Go to My library" : "Go to Resources"} 
        </Button>

    </div>)
}

export default ActivationSuccessTemplate;
